import { render, staticRenderFns } from "./Instituto.vue?vue&type=template&id=2b58dd26&scoped=true&lang=pug"
import script from "./Instituto.vue?vue&type=script&lang=js"
export * from "./Instituto.vue?vue&type=script&lang=js"
import style0 from "./Instituto.styl?vue&type=style&index=0&id=2b58dd26&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b58dd26",
  null
  
)

export default component.exports